export enum CustomPaymentPurposeType {
    AppraisalAndUnderwritingFee = 'Appraisal + Underwriting Fee',
    Appraisal = 'Appraisal',
    UnderwritingFee = 'Underwriting Fee',
    InterestOrExtension = 'Interest and/or Extension',
    Other = 'Other',
}
